DO.Subscribe('app:ready', function (e, $) {
	function init() {
		attachEvents();
	}

	function attachEvents() {
		var keys = [];
		keys[13] = 'enter';
		keys[32] = 'space';
		keys[9] = 'tab';
		keys[27] = 'esc';
		keys[38] = 'up';
		keys[40] = 'down';
		keys[37] = 'left';
		keys[39] = 'right';

		/**
         * Makes main menu controllable by keyboard
         */
		$(document.activeElement).keydown(function (e) {
			handleKeydown(e, keys);
		});
	}

	function handleLeftUp(target, e) {
		// Main menu focus
		if ($(target).attr('role') === 'menu' || $(target).attr('role') === 'submenu') {
			e.preventDefault();
			$(target).find('li:last').focus();
		}
		// Menu item
		if ($(target).attr('role') === 'menuitem') {
			e.preventDefault();
			$(target).prev('li').focus();
		}
	}

	function handleRightDown(target, e) {
		// Main menu focus
		if ($(target).attr('role') === 'menu' || $(target).attr('role') === 'submenu') {
			e.preventDefault();
			$(target).find('li:first').focus();
		}
		// Menu item
		if ($(target).attr('role') === 'menuitem') {
			e.preventDefault();
			$(target).next('li').focus();
		}
	}

	function handleEnterSpace(target, e) {
		// Menu item
		if ($(target).attr('role') === 'menuitem') {
			e.preventDefault();
			var link = $(target).find('a');
			if (link && $(link).attr('href')) {
				window.location = $(link).attr('href');
			}
		}
	}

	function handleKeydown(e, keys) {
		var target = e.target,
			key = e.which;

		// Left arrow + up
		if (keys[key] === 'left' || keys[key] === 'up') {
			handleLeftUp(target, e);
		}

		// Right arrow + down
		if (keys[key] === 'right' || keys[key] === 'down') {
			handleRightDown(target, e);
		}

		// Enter + Space
		if (keys[key] === 'enter' || keys[key] === 'space') {
			handleEnterSpace(target, e);
		}
	}

	init();
});

DO.Subscribe('app:ready', function(e, $) {
	function init() {
		// Open an accordion block if has requested anchor
		var identifier = window.location.hash.substring(1),
			target = identifier ? document.getElementById(identifier) : null,
			item = target ? $(target).closest('.accordion_item') : $();

		if (item.length) {
			openAnchor(item);
		}

		// Content link not tabbable unless content visible
		$('.accordion_item_content a').attr('tabindex', '-1');

		setup();
	}

	function setup() {
		attachEvents();
	}

	function attachEvents() {
		// Click on header div (allows clicking anywhere)
		$('.accordion .accordion_item_header').click(function(e) {
			if ($(this).hasClass('direct_link')) {
				// Allow default link behavior for direct links
				return;
			}

			e.preventDefault();

			var item = $(this).parent(),
				button = $(this).find('.accordion_item_header__action'),
				controlsId,
				panel;

			// Only proceed if there's a button (accordion items, not direct links)
			if (button.length === 0) {
				return;
			}

			controlsId = button.attr('aria-controls');

			if (!controlsId) {
				return;
			}

			// Escape the ID to handle special characters like spaces
			panel = $(document.getElementById(controlsId));

			// Proceed even if panel is empty - it should still open/close
			if (panel.length === 0) {
				return;
			}

			// Close
			if (item.hasClass('active')) {
				closeAccordion(item, panel, button);
			} else {
				openAccordion(item, panel, button);
			}
		});
	}

	function closeAccordion(item, panel, button) {
		item.removeClass('active');
		panel.removeClass('active');
		panel.attr('aria-hidden', 'true');
		panel.find('a').attr('tabindex', '-1');
		button.attr('aria-expanded', 'false');
		item.trigger('accordion:close');
	}

	function openAccordion(item, panel, button) {
		item.addClass('active');
		panel.addClass('active');
		panel.find('a').attr('tabindex', '0');
		panel.attr('aria-hidden', 'false');
		button.attr('aria-expanded', 'true');
		item.trigger('accordion:open');
	}

	function openAnchor(accordionItem) {
		var button = accordionItem.find('.accordion_item_header__action'),
			controlsId,
			panel;

		if (button.length && button.attr('aria-expanded') === 'false') {
			controlsId = button.attr('aria-controls');
			panel = $(document.getElementById(controlsId));
			if (panel.length) {
				openAccordion(accordionItem, panel, button);
			}
		}

		if (button.length) {
			button.focus();
		}
	}

	init();
});

DO.Subscribe('app:ready', function(e, $) {
    function isDifferentPage(url) {
        const sameDomain = url.startsWith('/'),
              linkUrl = new URL(sameDomain ? window.location.origin.concat(url) : url),
              currentUrl = new URL(window.location);

        // If the link is external, it's always a different page
        if (linkUrl.hostname !== currentUrl.hostname) return true;

        // Compare pathname
        return (
          linkUrl.pathname !== currentUrl.pathname
        );
      }

	/**
	* Animate scroll to anchor
	*/
	$('a[href*=\\#]').click(function(event) {
		var url = $(event.target).attr('href'),
			hash = url.substring(url.indexOf('#') + 1),
			target = $('a[name=' + hash + ']');

        if (isDifferentPage(url)) {
            return true;
        }

		if (target.length > 0) {
			event.preventDefault();
			$('html, body').animate({
				scrollTop: $(target).offset().top
			}, 500, function() {
				if (history.pushState) {
					history.pushState(null, null, url);
				} else {
					window.location = url;
				}
			});
		}
	});
});

//* Print function
// eslint-disable-next-line no-unused-vars
function printSection(selector) {
	var content = '',
		baseURL = $('base').attr('href');

	// Build content by querying the DOM via selector passed
	if ($.isArray(selector)) {
		$.each(selector, function (index, el) {
			content += $(el).html();
		});
	} else {
		content = $(selector).html();
	}
	// Build HTML to print
	$.ajax({
		type: 'GET',
		url: baseURL + 'home/GetPrintTemplate',
		complete: function (response) {
			var html = response.responseText,
				page = html.replace('[content]', content);
			setTimeout(function() {
				printPage(page);
			}, 200);
		}
	});
}

function printPage(page) {
	var target = $('#printDiv'),
		fullPage = $('#pageContent');

	target.removeClass('print-only--triggerable');
	fullPage.addClass('no-print'); // hide all other page content from print
	target.html(page);

	setTimeout(function() {
		window.print();
		target.empty();
		target.addClass('print-only--triggerable');
		fullPage.removeClass('no-print'); // hide all other page content from print
	}, 500);
}

(function($) {
	$(function () {
		$('.address-finder-field').each(function() {
			var form = $(this).closest('form'),
				wrap = $(this).closest('.field-wrap'),
				showLoading = function() {
					$(wrap).addClass('field-wrap--loading');
				},
				hideLoading = function() {
					$(wrap).removeClass('field-wrap--loading');
				};

			$(this).autocomplete({
				serviceUrl: '/AddressFinder/getAddress',
				minChars: 3,
				showNoSuggestionNotice: true,
				noSuggestionNotice: 'No results found',
				deferRequestBy: 1,
				transformResult: function(response) {
					return {
						suggestions: $.map(JSON.parse(response), function(dataItem) {
							return {
								value: dataItem.value['address'],
								data: {
									'ID': dataItem.data.ID,
									'Line1': dataItem.data.Line1,
									'Line2': dataItem.data.Line2,
									'UnitType': dataItem.data.UnitType,
									'SuburbName': dataItem.data.SuburbName,
									'TownCity': dataItem.data.TownCity,
									'PostCode': dataItem.data.PostCode
								}
							};
						})
					};
				},
				onSearchStart: function() {
					showLoading();
				},
				onSearchComplete: function() {
					hideLoading();
				},
				onSelect: function(suggestion) {
					hideLoading();

					if (typeof suggestion.data.UnitType === typeof undefined) {
						$(this).val(suggestion.data.Line1);
					} else {
						$(this).val(suggestion.data.Line1 + ', ' + suggestion.data.Line2);
					}

					$(form).find('input[name="PropertyRegion"]').val(suggestion.data.SuburbName);
					$(form).find('input[name="PropertyCity"]').val(suggestion.data.TownCity);
					$(form).find('input[name="PropertyPostCode"]').val(suggestion.data.PostCode);
				}
			});
		});
	});
})(jQuery);

DO.Subscribe('app:ready', function(e, $) {
	function init() {
		if ($('[data-type-alert]').length < 1) {
			return;
		}

		checkCookie($('[data-type-alert]'));
		attachEvents();
	}

	function attachEvents() {
		var dismiss = $('[data-alert-dismiss]');

		dismiss.on('click', function() {
			var alert = $(this).closest('[data-type-alert]');
			dismissAlert(alert);
		});
	}

	/**
	 * Handle really long notifications
	 * Note: this will kill the animation, as it removes max-height, but it's a super edgecase
	 *
	 * @param DOMObject | alert
	 */
	function adjustHeight(alert) {
		setTimeout(function() {
			var height = alert.css('max-height', 'none').height();

			if (height < 250) {
				alert.css('max-height', '');
			}
		}, 500);
	}

	/**
	 * @param DOMObject | alert
	 */
	function dismissAlert(alert) {
		alert.addClass('alert--hidden');

		setTimeout(function() {
			removeAlert(alert);
			setCookie('alertseen' + alert.attr('id'), true);
		}, 500);
	}

	/**
	 * Removes alert from the DOM, and adjusts parent object if needed
	 * @param DOMObject | alert
	 */
	function removeAlert(alert) {
		var parent = alert.closest('.hasalert');
		if (parent.length > 0) {
			parent.removeClass('hasalert');
		}
		alert.remove();
	}

	/**
	 * If Cookie exists for this alert, then the user has already dismissed it,
	 * remove the alert from the DOM.
	 * If a cookie doesn't exist, then show the alert
	 *
	 * @param DOMObjects | alerts
	 */
	function checkCookie(alerts) {
		var i = 0,
			alert,
			cookie;

		for (i = 0; i < alerts.length; i = i + 1) {
			alert = $(alerts[i]);

			cookie = getCookie('alertseen' + alert.attr('id'));

			if (cookie) {
				removeAlert(alert);
			} else {
				alert.removeClass('alert--hidden');
				adjustHeight(alert);
			}
		}
	}

	/**
	 * @param String | key, Mixed | value
	 */
	function setCookie(key, value) {
		var expires = new Date(),
			cookiePath = '/';
		expires.setTime(expires.getTime() + (200 * 24 * 60 * 60 * 1000));

		document.cookie = key + '=' + value + ';expires=' + expires.toUTCString() + '; path=' + cookiePath;
	}

	/**
	 * @param String | key
	 */
	function getCookie(key) {
		var keyValue = document.cookie.match('(^|;) ?' + key + '=([^;]*)(;|$)');
		return keyValue ? keyValue[2] : false;
	}

	init();
});

'use strict';

DO.Subscribe('app:css_loaded', function(e, $) {
	$('.carousel').each(function() {
		$(this).Rubik({
			hasControls: $(this).data('has-controls'),
			hasPager: $(this).data('has-pager'),
			startAt: $(this).data('start-at')
		});
	});
});
DO.Subscribe('ajax:success', function(e, $) {
	$('.carousel').each(function() {
		var carousel = $(this);
		if (!carousel.data('Rubik')) {
			carousel.Rubik({
				hasControls: carousel.data('has-controls'),
				hasPager: carousel.data('has-pager'),
				startAt: carousel.data('start-at')
			});
		}
	});
});

/**
 * Equalize the heights of rows across columns in a comparison table.
 */
DO.Subscribe(['app:ready'], function (e, $) {
    function equalizeRowHeights() {
        if ($(window).width() > 750) {
            $('.comparison-table__item-row').css('height', 'auto');
            let maxRowHeights = [];
            $('.comparison-table__col').each(function () {
                $(this).find('.comparison-table__item-row').each(function (index) {
                    maxRowHeights[index] = Math.max(maxRowHeights[index] || 0, $(this).outerHeight());
                });
            });
            $('.comparison-table__col').each(function () {
                $(this).find('.comparison-table__item-row').each(function (index) {
                    $(this).height(maxRowHeights[index] - 48);
                });
            });
        } else {
            $('.comparison-table__item-row').css('height', 'auto');
        }
    }

    function setUpComparisonTableButtons() {
        function toggleColumns(showCol, hideCol) {
            $(showCol)
            .removeClass('comparison-table__col--hide')
            .addClass('comparison-table__col--display');
            $(hideCol)
            .removeClass('comparison-table__col--display')
            .addClass('comparison-table__col--hide');
        }

        $('[data-show-col-one]').on('click', function() {
            if ($('[data-show-col-one]').hasClass('comparison-table__tab--active')) {
                return;
            }
            $('[data-show-col-one]').addClass('comparison-table__tab--active');
            $('[data-show-col-two]').removeClass('comparison-table__tab--active');
            toggleColumns('.comparison-table__col--one', '.comparison-table__col--two');
        });

        $('[data-show-col-two]').on('click', function() {
            if ($('[data-show-col-two]').hasClass('comparison-table__tab--active')) {
                return;
            }
            $('[data-show-col-two]').addClass('comparison-table__tab--active');
            $('[data-show-col-one]').removeClass('comparison-table__tab--active');
            toggleColumns('.comparison-table__col--two', '.comparison-table__col--one');
        });
    }

    $(document).ready(equalizeRowHeights);
    $(document).ready(setUpComparisonTableButtons);
    $(window).resize(function() {
        clearTimeout($.data(this, 'resizeTimer'));
        $.data(this, 'resizeTimer', setTimeout(equalizeRowHeights, 200));
    });
});

DO.Subscribe('app:ready', function(e, $) {
	$('.locale-page-selector__select').select2({
		placeholder: 'Choose Language',
		allowClear: true,
		width: 'style',
		minimumResultsForSearch: 30,
		dropdownCssClass: 'select-dropdown-container',
		dropdownAdapter: $.fn.select2.amd.require('CustomDropdownAdapter')
	});

	$(document).on('click', '.locale-selector-file__trigger', function() {
		var $trigger = $(this),
			expanded = $trigger.attr('aria-expanded') === 'true';

		$('.locale-selector-file__trigger').not($trigger).attr('aria-expanded', 'false');
		$('.locale-selector-file__menu').not('#' + $trigger.attr('aria-controls')).prop('hidden', true);

		$trigger.attr('aria-expanded', String(!expanded));
		$('#' + $trigger.attr('aria-controls')).prop('hidden', expanded);
	});

	$(document).on('click', function(e) {
		if (!$(e.target).closest('.locale-selector-file').length) {
			$('.locale-selector-file__trigger').attr('aria-expanded', 'false');
			$('.locale-selector-file__menu').prop('hidden', true);
		}
	});

	$(document).on('keydown', function(e) {
		if (e.key !== 'Escape') return;
		var $open = $('.locale-selector-file__trigger[aria-expanded="true"]');
		if (!$open.length) return;
		$open.attr('aria-expanded', 'false');
		$('#' + $open.attr('aria-controls')).prop('hidden', true);
		$open.trigger('focus');
	});
});

/*
 Restore main menu visibility when switching form portrait to landscape
 */
DO.Subscribe(['app:breakpointchange'], function(e, $) {
	var breakpoint = DO.CurrentBreakpoint(),
		large = ['large', 'xlarge', 'xxlarge', 'xxxlarge'];

	if ($.inArray(breakpoint, large)) {
		$('.header .header_nav ul').not(':visible').css('display', '');
	}
});

/**
* Custom JS for the landinggrid module
*/
DO.Subscribe(['app:ready'], function(e, $) {
	'use strict';

	// Enable tile border color change when hovering over tile title
	// Note: this is not exactly proper becaus eof the html structure
	// But we like to please the designers
	$('.landinggrid_title').on('mouseover', function(e) {
		$(this).parents('.landinggrid_section').addClass('hover');
	});

	$('.landinggrid_title').on('mouseout', function(e) {
		$(this).parents('.landinggrid_section').removeClass('hover');
	});
});

DO.Subscribe(['app:ready'], function (e, $) {
	$('#languageModal').modal();
});

DO.Subscribe('app:ready', function(e, $) {
	// Hide pagination and add show more button
	var pagination = $('.listing_pagination'),
		results = $('.listing_results .showmore'),
		url = results.data('next'),
		trigger = results.find('.btn__showmore').first();

	function init() {
		setup();
		submitOnDropdownChange();
	}

	function reInit() {
		url = results.data('next');
		trigger = results.find('.btn__showmore').first();

		trigger.on('click', function(e) {
			getMore();
		});
	}

	function setup() {
		// replace pagination with show more button
		pagination.addClass('listing_pagination__with_showmore');
		numResults();
		attachEvents();
	}

	function attachEvents() {
		// Bind event
		trigger.click(function(e) {
			getMore();
		});
	}

	// Fetch new results
	function getMore(evt) {
		$.ajax({
			url: url,
			success: function (data, status) {
				results.replaceWith(data);
				results = $('.listing_results .showmore');
				reInit();
			}
		});
	}

	function submitOnDropdownChange() {
		$('#Form_filter').find('select').change(function() {
			$(this).closest('form').submit();
		});
	}

	/**
	 Add number of result to the "All" filter
	 */
	function numResults() {
		var nresults = $('.listing_filters').data('nresults'),
			tag = $('.listing_filters label[for=Form_filter_type_All]'),
			html = $(tag).html(),
			tagContent;

		if (nresults && tag && html) {
			tagContent = html + ' (' + nresults + ')';
			$(tag).html(tagContent);
		}
	}

	init();
});


DO.Subscribe('app:ready', function (e, $) {
	var map,
		infowindow,
		initMap,
		mapsLoaded = false,

		loadGoogleMapsApi = function (options) {
			// Modified from https://github.com/yuanqing/load-google-maps-api

			var CALLBACK_NAME = '__googleMapsApiOnLoadCallback',
				OPTIONS_KEYS = [
					'channel',
					'client',
					'key',
					'language',
					'region',
					'v'
				],
				promise = null;
			options = options || {};

			if (!promise) {
				promise = $.Deferred(function (differ) {
					// Reject the differ after a timeout
					var scriptElement,
						params,
						timeoutId = setTimeout(function () {
							window[CALLBACK_NAME] = function () { }; // Set the on load callback to a no-op
							differ.reject(
								new Error('Could not load the Google Maps API')
							);
						}, options.timeout || 10000);

					// Hook up the on load callback
					window[CALLBACK_NAME] = function () {
						if (timeoutId !== null) {
							clearTimeout(timeoutId);
						}
						differ.resolve(window.google.maps);
						delete window[CALLBACK_NAME];
					};

					// Prepare the `script` tag to be inserted into the page
					scriptElement = document.createElement('script');
					params = ['callback=' + CALLBACK_NAME];
					OPTIONS_KEYS.forEach(function (key) {
						if (options[key]) {
							params.push(key + '=' + options[key]);
						}
					});
					if (options.libraries && options.libraries.length) {
						params.push('libraries=' + options.libraries.join(','));
					}
					scriptElement.src =
                'https://maps.googleapis.com/maps/api/js?' +
                params.join('&');
					scriptElement.async = false;

					// Insert the `script` tag
					document.body.appendChild(scriptElement);
				});
			}

			return promise;
		},

		loadMaps = function () {
			if (mapsLoaded) {
				return false;
			}

			var mapEl = document.getElementById('event-map');
			loadGoogleMapsApi({
				key: mapEl.dataset.key,
				libraries: ['places']
			})
				.done(function () {
					$.getScript(
						'/public/_resources/app/js/markerwithlabel_packed.js'
					).done(function () {
						mapsLoaded = true;
						initMap();
					});
				})
				.fail(function (error) {
					console.error(error);
				});

			return true;
		};

	initMap = function () {
		var mapEl = document.getElementById('event-map'),
			newZealand,
			request,
			service;
		if (mapEl) {
			newZealand = new google.maps.LatLng(-40.4509647, 166.3335486);

			infowindow = new google.maps.InfoWindow();

			map = new google.maps.Map(mapEl, {
				center: newZealand,
				zoom: 15
			});

			map.setOptions({
				styles: [
					{
						featureType: 'poi',
						stylers: [{ visibility: 'off' }]
					}
				],
				zoomControl: false,
				mapTypeControl: false,
				scaleControl: false,
				streetViewControl: false,
				rotateControl: false,
				fullscreenControl: false
			});

			if (
				parseInt(mapEl.dataset.locationOverride) &&
                parseInt(mapEl.dataset.titleOverride)
			) {
				const location = new google.maps.LatLng(
					mapEl.dataset.lat,
					mapEl.dataset.lng
				);

				createMarker(mapEl.dataset.title, location);
				map.setCenter(location);
			} else {
				request = {
					query: mapEl.dataset.location,
					fields: ['name', 'geometry']
				};

				service = new google.maps.places.PlacesService(map);

				service.findPlaceFromQuery(request, function (results, status) {
					if (status === google.maps.places.PlacesServiceStatus.OK) {
						const location = parseInt(
							mapEl.dataset.locationOverride
						)
							? new google.maps.LatLng(
								mapEl.dataset.lat,
								mapEl.dataset.lng
							)
							: results[0].geometry.location;

						createMarker(results[0], location);
						map.setCenter(location);
					}
				});
			}
		}
	};

	function createMarker(place, location) {
		const mapEl = document.getElementById('event-map'),

			placeName = parseInt(mapEl.dataset.titleOverride)
				? mapEl.dataset.title
				: place.name;

		var marker = new MarkerWithLabel({
			map: map,
			labelContent: placeName,
			labelAnchor: new google.maps.Point(-16, 35),
			labelStyle: {
				color: '#BF2113',
				fontSize: '14px'
			},
			position: location
		});

		google.maps.event.addListener(marker, 'click', function () {
			var location = parseInt(mapEl.dataset.locationOverride) ? mapEl.dataset.lat + ',' + mapEl.dataset.lng : mapEl.dataset.location;
			infowindow.setContent(createInfoWindowContent(placeName, mapEl.dataset.location, location));
			infowindow.open(map, this);
		});
	}

	function hideShowMap() {
		var mapContainer = document.querySelector('.event-details-item-map'),
			hideShowButton = document.querySelector(
				'.event-details-map-button'
			);

		hideShowButton.addEventListener('click', function (e) {
			e.preventDefault();
			var toggleButton = e.target;

			if (toggleButton.dataset.toggle === 'closed') {
				if (!mapsLoaded) {
					loadMaps();
				}
				toggleButton.innerText = 'Close Map';
				toggleButton.dataset.toggle = 'open';
				$(mapContainer).slideDown();
			} else {
				toggleButton.innerText = 'View Map';
				toggleButton.dataset.toggle = 'closed';
				$(mapContainer).slideUp();
			}
		});
	}

	function createInfoWindowContent(title, address, location) {
		if (title === address) {
			address = '';
		}

		var content =
        '<div class="poi-info-window gm-style">' +
        '<div>' +
        '<div class="title full-width">' + title + '</div>' +
        '<div class="map-address address">' +
        '<div class="address-line">' + address + '</div>' +
        '</div>' +
        '</div>' +
        '<div class="view-link">' +
        '<a target="_blank" href="https://www.google.com/maps/search/?api=1&query=' + encodeURIComponent(location) + '">' +
        '<span>View on Google Maps</span>' +
        '</a>' +
        '</div>' +
        '</div>';

		return content;
	}

	if (document.getElementById('event-map')) {
		hideShowMap();
	}
});


DO.Subscribe('app:ready', function(e, $) {
	/**
     * Detect if MarketRent Finder is on page
     * and retrieve MarketRentPage URL
     */
	function init() {
		var finder = $('[data-market-rent]'),
			queryUrl = location.search;

		if (finder.length < 1) {
			return;
		}

		if ($(location).attr('pathname') === '/' || queryUrl === '') {
			$('#load').removeClass('loaded');
			$('#mrf-values').removeClass('mrf_values');

			$('#load').addClass('load');
			$('#mrf-values').addClass('mrf-values');
		}

		if (finder.data('haslocation') === true) {
			updateMarketValueFromLocation(finder);
		}

		activateAutoComplete();
		activateTooltip();
		adjustLocationValue();
	}

	/**
     * Uses the ipinfo.io webservice to get the postcode, suburb and city of the area
     * Will return
     */
	function updateMarketValueFromLocation(finder) {
		var url = finder.data('ajax'),
			action,
			urlParts;

		if (!url) {
			return;
		}

		urlParts = url.split('?');

		action = urlParts[0] + 'updateMarketValueLocation';
		if (urlParts?.[1]) action += '?' + urlParts[1];

		$.get('https://ipinfo.io?token=8b789a9b6b35d7', function (response) {
			getMarketValueForLocation(response.postal, response.city, response.region, action);
		}, 'jsonp').fail(function() {
			$('#load').removeClass('load');
			$('#mrf-values').removeClass('mrf-values');
			$('#mrf-values').addClass('mrf_values');
		});
	}

	/**
     * Attempt to refresh the market-rent-finder with local values
     */
	function getMarketValueForLocation(postcode, suburb, city, action) {
		var homepage = $('[data-pagetype="homepage"]'),
			updateTable = homepage.length <= 0,
			table = $('[data-market-rent-table]'),
			finder = $('[data-market-rent]');

		$.ajax({
			type: 'GET',
			url: action,
			cache: false,
			data: {
				// postcode: postcode, // uncoment when postcode search is ready
				ajax_suburb: suburb,
				ajax_city: city
			}
		}).done(function (response) {
			if (typeof response !== 'string' || response === '') {
				return;
			}

			var json = JSON.parse(response);

			if (!json.Finder) {
				return;
			}

			finder.replaceWith(json.Finder);
			activateAutoComplete();
			adjustLocationValue();

			if (updateTable) {
				table.replaceWith(json.Table);
				activateTooltip();
			}
		});
	}

	/**
     * Suggestion on City Suburb Field
     */

	var MIN_CHARS = 3,
		DEFER_MS = 250;

	function activateAutoComplete() {
		var field = $('input[data-autocomplete = "on"]'),
			suggestionURL = $(field).data('ajaxurl') + 'suggestLocations';

		field.devbridgeAutocomplete({
			serviceUrl: suggestionURL,
			minChars: MIN_CHARS,
			deferRequestBy: DEFER_MS,
			groupBy: 'city'
		});

		activateMinCharsHint(field);
	}

	/**
	 * Reveal the template hint while the query sits below devbridge's minChars threshold.
	 *
	 * @param {JQuery} field
	 */
	function activateMinCharsHint(field) {
		field.each(function () {
			var input = $(this),
				hint = input.closest('.field_wrapper').find('.marketrent-finder__hint');

			input.on('keyup input', function () {
				clearTimeout(input.data('hintTimer'));
				input.data('hintTimer', setTimeout(function () {
					var length = $.trim(input.val()).length;

					hint.toggleClass(
						'marketrent-finder__hint--visible',
						length > 0 && length < MIN_CHARS
					);
				}, DEFER_MS));
			});
		});
	}

	function activateTooltip() {
		$('[data-toggle="tooltip"]').tooltip({
			container: 'body',
			animation: true
		});
	}

	/*
    * Replace set value from placeholder ajax value
    */
	function adjustLocationValue() {
		$('#Form_market-rent-filter').submit(function() {
			var input = $(this).find('#Form_market-rent-filter_location'),
				placeholder = $(input).attr('placeholder'),
				defaultPlaceholder = 'City or Suburb',
				value = $(input).val();

			if (!value && placeholder !== defaultPlaceholder) {
				$(input).val(placeholder);
			}

			return true;
		});
	}

	init();
});

DO.Subscribe(['app:ready'], function(e, $) {
	/**
	* Mobile Nav
	*/

	var menuLink = $('.mobile_nav_link a'),
		menuControl = $('.mobile_nav_chevron'),
		trigger = $('.nav_open_button'),
		overlay = $('.nav_overlay'),
		ctrlClose = overlay.find('button.nav_close');

	// Open a link's submenu when it's clicked
	menuLink.click(function(e) {
		var link = $(this),
			menu = link.siblings('.mobile_nav_list'),
			item = link.closest('.mobile_nav_link');

		// Close any open sibling menus
		closeOpenMenus(item);

		// Only call toggleMenu if the menu isn't open already, otherwise just follow the link
		if (menu.length > 0 && !link.parent().hasClass('mobile_nav_link--active')) {
			e.preventDefault();
			toggleMenu(menu);
		}
	});

	// Toggle a link's submenu when it's chevron is clicked
	menuControl.click(function() {
		var link = $(this).siblings('a'),
			menu = link.siblings('.mobile_nav_list'),
			item = link.closest('.mobile_nav_link');

		// Close any open sibling menus
		closeOpenMenus(item);

		if (menu.length > 0) {
			toggleMenu(menu);
		}
	});

	function toggleMenu(menu) {
		menu.stop().slideToggle('fast').toggleClass('mobile_nav_list--open');
		menu.closest('.mobile_nav_link').toggleClass('mobile_nav_link--active');
	}

	function closeOpenMenus(item) {
		var menu = item.siblings().children('.mobile_nav_list--open:not(.mobile_nav_list--first)');

		menu
			.slideToggle('fast')
			.removeClass('mobile_nav_list--open')
			.attr('aria-hidden', 'true')
			.closest('li').removeClass('mobile_nav_link--active');
	}

	function openNav(evt) {
		evt.preventDefault();
		overlay.css('visibility', 'visible');
		overlay.addClass('open');
		overlay.animate({'scrollTop': 0}, 500);
		$('html').addClass('overlay-opened');
		$('.aria-main-content').attr('aria-hidden', true).attr('tabindex', -1);
		overlay.attr('aria-hidden', false);
		ctrlClose.focus();
	}

	function closeNav(evt) {
		overlay.css({'top': '', 'bottom': ''});
		overlay.removeClass('open');
		setTimeout(function() {
			$('html').removeClass('overlay-opened');
			$('.aria-main-content').attr('aria-hidden', false).attr('tabindex', 0);
			overlay.attr('aria-hidden', true);
			overlay.css('visibility', 'hidden');
		}, 500);
	}

	$(trigger).on('click', function(e) {
		openNav(e);
	});

	$(ctrlClose).on('click', function(e) {
		closeNav(e);
	});
});

DO.Subscribe('app:ready', function(e, $) {
	/**
      Load more results on demand
     */
	var listing = $('.wrapper__newsevents'),
		showmore = listing.find('.btn__showmore');

	function init() {
		/**
         * Add extra class to news listing tags that break onto two lines
         */
		$('.news_results .news_item_headtext').each(function() {
			if ($(this).outerHeight() > 25) {
				$(this).closest('.news_item_head').addClass('news_item_head__long');
			}
		});
		attachEvents();
	}

	function attachEvents() {
		showmore.on('click', function(e) {
			e.preventDefault();

			$(this).addClass('loading');

			doAjax.call(this);
		});

		/**
         Trigger form submit when changing type
         */
		$('.newseventform input.radio').on('change', function(e) {
			$('.newseventform').find('input.action').trigger('click');
		});

		/**
         Toggle news filters
         */
		$('.news_filter [data-toggle]').on('click', function(e) {
			filterToggle.call(this);
		});
	}

	function handleResult(data, resultArea) {
		var results = $(data).find('.news_results .news_item'),
			moreButton,
			nextUrl;

		if (results.length > 0) {
			resultArea.append(results);
		}

		moreButton = $(data).find('.btn__showmore');
		if (moreButton.length === 1) {
			nextUrl = moreButton.prop('href');
			showmore.prop('href', nextUrl);
		} else {
			showmore.remove();
		}
	}

	function doAjax() {
		var url = $(this).prop('href'),
			resultArea = listing.find('.news_results');

		$.ajax({
			url: url,
			success: function (data, status) {
				handleResult(data, resultArea);
			},
			complete: function (data, status) {
				showmore.removeClass('loading');
			}
		});
	}

	function filterToggle() {
		var button = $(this),
			selector = button.data('toggle'),
			filterDiv = $(selector),
			others = $('.news_filter_drop:not(' + selector + ')');

		$('.news_filter [data-toggle]').not(this).removeClass('open');
		button.toggleClass('open');
		others.attr('aria-hidden', 'true');
		others.find('a').attr('tabindex', '-1');

		if (filterDiv.attr('aria-hidden') === 'false') {
			filterDiv.attr('aria-hidden', 'true');
			filterDiv.find('a').attr('tabindex', '-1');
		} else {
			filterDiv.attr('aria-hidden', 'false');
			filterDiv.find('a').attr('tabindex', '0');
		}
	}

	init();
});

DO.Subscribe(['app:ready'], function (e, $) {
    function setUpProcessAccordion() {
        $('[data-process-read-more]').on('click', function(event) {
            event.preventDefault();

            const button = $(this),
                parentItem = button.closest('[data-process-item]'),
                content = parentItem.find('[data-process-content]'),
                isExpanded = button.attr('aria-expanded') === 'true';

            button.attr('aria-expanded', !isExpanded);
            content.attr('aria-hidden', isExpanded);

            parentItem.toggleClass('process__item--active');

            // Set focus to the content if expanded
            if (!isExpanded) {
                content.focus();
                button.text('Close');
            } else {
                button.text(button.data('original-copy'));
            }
        });
    }

    $(document).ready(setUpProcessAccordion);
});

DO.Subscribe('app:ready', function (e, $) {
	function init() {
		if ($('[data-quick-exit-button]').length < 1) {
			return;
		}
		attachEvents();
	}

	function attachEvents() {
		let quickExitButton = $('[data-quick-exit-button]');

		quickExitButton.on('click', function () {
			quickExit();
		});
	}

	/**
	 * Exit the current webpage in a discreet manner
	 *
	 * 1. Set the HTML body to be display:none so that the user doesn't see the page load before the redirect happens.
	 * 2. Push the home page to the top of the history stack so on back button press they go there.
	 * 3. Redirect to the CMS set URL
	 */
	function quickExit() {
		$('body').css('display', 'none');
		window.history.pushState({}, '', '/');
		window.location.href = $('[data-quick-exit-button]').attr('data-quick-exit-url');
	}

	init();
});

DO.Subscribe(['app:ready', 'ajax:success'], function(e, $) {
	function init() {
		$('.rating').each(function() {
			var el = $(this);

			setup(el);
		});
	}

	function setup(el) {
		attachEvents(el);
		updateChecked(el);
	}

	function attachEvents(el) {
		var stars = el.find(
				'form:not([disabled]) .optionset:not([disabled]) > .optionset__option'
			),
			commentsLabel = el.find('.rating_comments label.left');

		stars.on({
			mouseenter: function() {
				$(this)
					.prevAll('.optionset__option:not(.rating-hovered)')
					.addBack()
					.addClass('rating-hovered');
			},
			mouseleave: function() {
				$(this)
					.prevAll('.optionset__option')
					.addBack()
					.removeClass('rating-hovered');
			},
			click: function() {
				manageSelected($(this));
			},
			keyup: function(e) {
				// Ensure correct stars are highlighted visually when navigating with keyboard
				switch (e.keyCode) {
					// Detect cursor keys
					case 37:
					case 38:
					case 39:
					case 40:
						manageSelected($(this));
						break;

					default:
                    // Do nothing for other keys
				}
			}
		});

		stars.on('click', function(e) {
			enableComments(el, e);
		});

		commentsLabel.on('click', function(e) {
			enableComments(el, e);
		});
	}

	function updateChecked() {
		$('.rating .optionset input:checked').each(function() {
			var wrapper = $(this).parent();
			wrapper.prevAll('.optionset__option')
				.addBack()
				.addClass('rating-selected');

			wrapper.off('mouseenter mouseleave click');
		});
	}

	function enableComments(el, e) {
		var stars = el.find(
				'form:not([disabled]) .optionset:not([disabled]) > .optionset__option'
			),
			comments = el.find('.rating_comments .middleColumn'),
			commentsLabel = el.find('.rating_comments label.left'),
			actions = el.find('.btn-toolbar');

		commentsLabel.addClass('sr-only');
		comments.addClass('active');
		actions.addClass('active');
		stars.off('click', enableComments);
		comments.off('click', enableComments);
	}

	function manageSelected(item) {
		var input = item.find('input');

		if (input.is(':checked')) {
			input.prop('checked', false);
			item
				.siblings('.optionset__option')
				.addBack()
				.removeClass('rating-selected');
		} else {
			input.prop('checked', true);
			item.nextAll('.optionset__option').removeClass('rating-selected');
			item
				.prevAll('.optionset__option')
				.addBack()
				.addClass('rating-selected');
		}
		input.focus();
	}

	init();
});

/* global grecaptcha */

/**
 * Mints a fresh reCAPTCHA v3 token on submit for every captcha protected form.
 */
DO.Subscribe('app:ready', (event, $) => {
	const TOKEN_TIMEOUT = 10000,
		bind = (form, input) => {
			let pending = false,
				resubmitting = false;

			form.addEventListener('submit', (submitEvent) => {
				if (resubmitting) {
					return;
				}

				submitEvent.preventDefault();

				if (pending) {
					return;
				}

				pending = true;

				const submitter = submitEvent.submitter || form.querySelector('[type="submit"]'),
					release = () => {
						pending = false;
						form.removeAttribute('aria-busy');

						if (submitter) {
							submitter.removeAttribute('aria-disabled');
						}
					},
					fail = () => {
						input.value = '';
						release();

						if (submitter) {
							submitter.focus();
						}
					},
					send = () => {
						resubmitting = true;

						if (typeof form.requestSubmit === 'function') {
							form.requestSubmit(submitter);
						} else {
							form.submit();
						}

						resubmitting = false;
						release();
					};

				form.setAttribute('aria-busy', 'true');

				if (submitter) {
					submitter.setAttribute('aria-disabled', 'true');
				}

				if (typeof grecaptcha === 'undefined') {
					send();
					return;
				}

				Promise.race([
					new Promise((resolve, reject) => {
						grecaptcha.ready(() => {
							Promise.resolve(grecaptcha.execute(input.dataset.sitekey, { action: 'submit' }))
								.then(resolve)
								.catch(reject);
						});
					}),
					new Promise((resolve) => window.setTimeout(resolve, TOKEN_TIMEOUT))
				])
					.then((token) => {
						if (!token) {
							fail();
							return;
						}

						input.value = token;
						send();
					})
					.catch(fail);
			});
		};

	$('input[name="g-recaptcha-response"]').each((index, input) => {
		const form = input.form;

		if (form && !$(form).closest('#subscribe_modal').length) {
			bind(form, input);
		}
	});
});

DO.Subscribe('app:ready', function (e, $) {
    if ($('#Form_filter').length > 0) {
        var searchParams = new URLSearchParams(window.location.search);
        // Apply saved search parameters to form inputs and selects
        document.querySelectorAll('#Form_filter input, #Form_filter select').forEach(function(input) {
            if (searchParams.has(input.name)) {
                input.value = searchParams.get(input.name);
            }
        });

        // Bind the submit event to the form
        $('#Form_filter').on('submit', function (event) {
            $('.listing_results').addClass('listing_results--loading');
            $('.popular-resources').addClass('popular-resources--loading');
            $('.listing_results-loading').addClass('listing_results-loading--display');
        });
    }
});

DO.Subscribe('app:ready', function(e, $) {
	$('.link_action__related').on('click', function() {
		$('.link__file').first().focus();
	});
});

/**
 * Wraps overflowing tables in a scroll region that keyboard-only users can reach
 * and scroll, with paging buttons at each edge once there is more table to see.
 */
DO.Subscribe(['app:ready'], (e, $) => {
	'use strict';

	const RESIZE_DELAY = 150,
		SCROLL_RATIO = 0.5,
		EDGE_BUFFER = 1,
		labelCounts = {},

		/**
		 * Accessible name for a scroll region, numbered when it would otherwise repeat.
		 */
		regionLabel = ($scroll) => {
			const label = $scroll.find('caption').first().text().trim() ||
				$scroll.prevAll('h1, h2, h3, h4, h5, h6').first().text().trim() ||
				'Table';

			labelCounts[label] = (labelCounts[label] || 0) + 1;

			return labelCounts[label] > 1 ? label + ' ' + labelCounts[label] : label;
		},

		button = (direction, label) => $('<button>', {
			'type': 'button',
			'class': 'table-scroll__btn table-scroll__btn--' + direction,
			'aria-label': label
		}),

		scrollBy = ($wrapper, sign) => {
			const wrapper = $wrapper.get(0),
				reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

			wrapper.scrollBy({
				left: sign * wrapper.clientWidth * SCROLL_RATIO,
				behavior: reduceMotion ? 'auto' : 'smooth'
			});
		},

		/**
		 * Hands focus back to the scroll region before a button is hidden, so a
		 * keyboard user who reaches an edge is not dropped back to the document.
		 */
		setAvailability = ($btn, available, $wrapper) => {
			if (!available && $btn.is(document.activeElement)) {
				$wrapper.trigger('focus');
			}

			$btn.toggleClass('is-available', available);
		},

		sync = ($scroll) => {
			const $wrapper = $scroll.children('.table-wrapper'),
				wrapper = $wrapper.get(0),
				overflowing = wrapper.scrollWidth > wrapper.clientWidth,
				remaining = wrapper.scrollWidth - wrapper.clientWidth - wrapper.scrollLeft;

			if (overflowing) {
				$wrapper.attr({
					'tabindex': '0',
					'role': 'region',
					'aria-label': $scroll.data('regionLabel')
				});
			} else {
				$wrapper.removeAttr('tabindex role aria-label');
			}

			setAvailability($scroll.find('.table-scroll__btn--prev'), wrapper.scrollLeft > EDGE_BUFFER, $wrapper);
			setAvailability($scroll.find('.table-scroll__btn--next'), remaining > EDGE_BUFFER, $wrapper);
		},

		build = ($table) => {
			$table
				.wrap('<div class="table-wrapper"></div>')
				.parent()
				.wrap('<div class="table-scroll"></div>');

			const $wrapper = $table.parent('.table-wrapper'),
				$scroll = $wrapper.parent('.table-scroll');

			$scroll
				.prepend(button('prev', 'Scroll table left'))
				.append(button('next', 'Scroll table right'))
				.on('click', '.table-scroll__btn--prev', () => scrollBy($wrapper, -1))
				.on('click', '.table-scroll__btn--next', () => scrollBy($wrapper, 1));

			$wrapper.on('scroll', () => sync($scroll));

			$scroll.data('regionLabel', regionLabel($scroll));

			return $scroll;
		},

		refresh = () => {
			$('table').each((index, table) => {
				const $table = $(table);
				let $scroll = $table.closest('.table-scroll');

				if (!$scroll.length) {
					if ($table.prop('scrollWidth') <= $table.parent().width()) {
						return;
					}

					$scroll = build($table);
				}

				sync($scroll);
			});
		};

	let resizeTimer = null;

	$(window).on('resize', () => {
		window.clearTimeout(resizeTimer);
		resizeTimer = window.setTimeout(refresh, RESIZE_DELAY);
	});

	refresh();
});

/**
 * Search controls
 */
DO.Subscribe(['app:ready'], function(e, $) {
	'use strict';

	function init() {
		setup($(document));
	}

	function setup(scope) {
		if (scope.find('[data-searchform]').length < 1) {
			return;
		}

		attachEvents(scope);
	}

	function attachEvents(scope) {
		var input = $('[data-seachform-field]');

		$('[data-searchform-trigger]').on('click', function (e) {
			e.preventDefault();
			toggleSearch($(this));
		});

		input.keyup(function (e) {
			handleEnterKey(e, $(this));
		});

		input.on('focus', function (e) {
			handleFocus(this, 'in');
		}).on('focusout', function (e) {
			handleFocus(this, 'out');
		});

		$('[data-searchform-submit]').click(function (e) {
			e.preventDefault();
			handleSearchSubmit(this);
		});

        initializeAutocomplete(input);

        function setupRecordClick() {
            const documentId = $(this).data('document-id'),
                keyword = new URLSearchParams(window.location.search).get(
                    'keyword'),
                clickType = $(this).data('click-type');
            recordClick(documentId, keyword, clickType);
        }

        /**
         * For link clicks we first need to prevent the default action, record the click, then trigger the default action
         *
         * @param e
         */
        function handleLinkClick(e) {
            e.preventDefault(); // Prevent the default action
            setupRecordClick.call(this);
            // Perform the action intended by this link, e.g., navigate or whatever else
            const href = $(this).attr('href');
            if (href) {
                window.location.href = href;
            }
        }

        $(document).on('click', '[data-search-click]', setupRecordClick);
        $(document).on('click', '[data-search-click-link]', handleLinkClick);

        // this bit is required for any components expected to load inside a dynamically fetched component
		// eg docks/slideout panels, lazy loaded accordions, dynamic results
		if (scope.is(document)) {
			$(document).on('ajaxpages:contentloaded', function (e, data) {
				setup(data.target);
			});
		}
	}

    /**
     * @param documentId
     * @param keyword
     * @param clickType
     */
    function recordClick(documentId, keyword, clickType) {
        $.post('/home/search/recordClick', { documentId: documentId, keyword: keyword, clickType: clickType })
        .fail(function() {
            console.log('Error recording click');
        });
    }

    /**
     * Initialize the autocomplete
     * @param input
     */
    function initializeAutocomplete(input) {
        const suggestionURL = input.data('suggestionsurl'),
         suggestionMinLength = input.data('suggestionsminlength'),
            clickToSubmitSearch = input.data('clicktosubmitsearch');

        if (!suggestionURL) {
            return;
        }

        input.devbridgeAutocomplete({
            serviceUrl: suggestionURL,
            minChars: suggestionMinLength || 3,
            deferRequestBy: 100,
            beforeRender: function (container) {
                $(container).addClass('autocomplete-suggestions--search');
                $('.autocomplete-suggestion', container).each(function() {
                    $(this).addClass('autocomplete-suggestion--search');
                });
            },
            onSelect: function (suggestion) {
                if (clickToSubmitSearch) {
                    const form = input.closest('form');
                    if (form.length > 0) {
                        input.val(suggestion.value);
                        form.submit();
                    }
                } else {
                    // Default behavior: just set the input value
                    input.val(suggestion.value);
                }
            }
        });
    }

	/**
     * Add and remove opened state on focus
     * @param self
     * @param state
     */
    function handleFocus(self, state) {
        var target = $(self).closest('[data-searchform-parent]'),
            sibling = target.siblings('[data-locale-select]'),
            input = $(self),
            isMobile = ['xsmall', 'medium'].indexOf(DO.CurrentBreakpoint()) > -1;

        if (isMobile) {
            return;
        }

        if (state === 'in') {
            target.addClass('opened');
            sibling.addClass('searchopened');
            console.log('focus');
            // Dispose the existing autocomplete before reinitializing so that the position is correct
            input.devbridgeAutocomplete('dispose');
            initializeAutocomplete(input); // Reinitialize autocomplete when focused
        } else {
            target.removeClass('opened');
            sibling.removeClass('searchopened');
        }
    }

	/**
     * This method is to handle removing the open state at desktop
     * @param self
     */
	function handleSearchSubmit(self) {
		var target = $(self).closest('[data-searchform-parent]'),
			sibling = target.siblings('[data-locale-select]'),
			input = target.find('[data-seachform-field]').first(),
			form = target.find('[data-searchform]').first();

		if (input.val().length > 0) {
			form.submit();
			return;
		}

		target.removeClass('opened');
		sibling.removeClass('searchopened');
	}

	/**
     * Provided its not empty, submit the form when enter is pressed
     * @param e
     * @param self
     */
	function handleEnterKey(e, self) {
		var form = self.closest('[data-searchform]');

		if (e.keyCode === 13 && self.val() !== '') {
			form.submit();
		}
	}

	/**
     * Toggle the open/closed state of the search form
     * @param self
     */
	function toggleSearch(self) {
		var target = self.data('searchform-trigger'),
			sibling = $(target).siblings('[data-locale-select]'),
			input = $(target).find('[data-seachform-field]').first();

		if ($(target).hasClass('opened')) {
			$(target).removeClass('opened');
			sibling.removeClass('searchopened');
			return;
		}

		input.focus();
		$(target).addClass('opened');
		sibling.addClass('searchopened');
	}

	init();
});

/**
 * Create popup window for social share links
 */
DO.Subscribe(['app:ready'], function(e, $) {
	'use strict';

	var twitterWindowSize = {
			width: 500,
			height: 350
		};

	function init() {
		var sharePopUps = document.querySelectorAll('.share-popup'),
			index;

		for (index = 0; index < sharePopUps.length; index++) {
			sharePopUp(sharePopUps, index);
		}
	}

	function sharePopUp(sharePopUps, index) {
		var sharePopup = sharePopUps[index];
		sharePopup.addEventListener('click', function (e) {
			e.preventDefault();

			var socialType = e.target.dataset.socialType,
				href = e.target.href;
			switch (socialType) {
				case 'twitter':
					twitterShare(socialType, href);
					break;
				default:
					break;
			}
		});
		return sharePopup;
	}

	function getWindowSize(socialType) {
		var result;
		switch (socialType) {
			case 'twitter':
				result = {
					width: twitterWindowSize.width,
					height: twitterWindowSize.height
				};
				break;
			default:
				result = {
					width: twitterWindowSize.width,
					height: twitterWindowSize.heigh
				};
				break;
		}
		return result;
	}

	function getWindowOptions(socialType) {
		var windowSize = getWindowSize(socialType),
			left = window.innerWidth / 2 - windowSize.width / 2,
			top = window.innerHeight / 2 - windowSize.height / 2;

		return [
			'resizable,scrollbars,status',
			'height=' + windowSize.height,
			'width=' + windowSize.width,
			'left=' + left,
			'top=' + top
		].join();
	}

	function twitterShare(socialType, href) {
		var win = window.open(href, 'Share', getWindowOptions(socialType));
		win.opener = null;
	}

	init();
});

/* eslint-disable no-unused-vars */
/* eslint-disable no-undef */
/**
 * Show MailChimp subscribe form inside modal
 */
DO.Subscribe(['app:ready'], function (e, $) {
	'use strict';

	function init() {
		bindEvents();
	}

	/**
     * Bind modal trigger events, or load modal on detection of hash
     */
	function bindEvents() {
		$('[data-target="#subscribe_modal"]').on('click', function (e) {
			loadSubscribeModal();
		});

		if (window.location.hash === '#subscribe') {
			$('[data-target="#subscribe_modal"]').trigger('click');
		}
	}

	/**
     * Fetch Content for the modal
     */
	function loadSubscribeModal() {
		var modal = $('#subscribe_modal'),
			url = modal.attr('data-source'),
			title = document.title,
			location = window.location.href.split('#')[0];

		// Don't load form again if it's already there
		if (modal.hasClass('modal--active')) {
			return;
		}

		$('#subscribe_modal_content').html('');
		modal.addClass('modal--loading');

		$.ajax({
			url: url,
			type: 'get',
			success: function (html) {
				modal.find('#subscribe_modal_content').html($(html).find('#ajax_content'));

				// Add active class so we know not to send request
				// to load form again when it is closed and re-opened
				modal.addClass('modal--active');

				// Set focus to first field
				modal.find('input[type=email]').focus();

				bindSubscribeForm();
			},
			error: function (response) {
				console.log('Error: ' + response);
			}
		});

		modal.on('show.bs.modal', function (event) {
			// Set focus to close button when modal opens
			modal.find('.modal-close').focus();

			// Add class to <html> so we can disable scrolling on it
			// when modal is open otherwise duplicate scrollbars
			$('html').addClass('has_modal');
			history.replaceState(null, 'Subscribe', location + '#subscribe');
			document.title = 'Subscribe';
		});

		modal.on('hide.bs.modal', function (event) {
			$('html').removeClass('has_modal');
			history.replaceState(null, title, location);
			document.title = title;
		});
	}

	/**
     * Bind submission of the subscribe form
     */
	function bindSubscribeForm() {
		var modal = $('#subscribe_modal'),
			form = modal.find('form'),
			recaptchaField = form.find('input[name="g-recaptcha-response"]'),
			siteKey = recaptchaField.attr('data-sitekey');

		if (recaptchaField.length && typeof grecaptcha === 'undefined') {
			// eslint-disable-next-line one-var
			var script = document.createElement('script');
			script.src = 'https://www.google.com/recaptcha/api.js?render=' + siteKey;
			document.body.appendChild(script);
			script.onload = function() {
                modal.removeClass('modal--loading');
			};
		} else {
            modal.removeClass('modal--loading');
        }

		form.parsley().on('form:submit', function() {
            $('[data-recaptcha-error]').slideUp();
			if (!recaptchaField.length || typeof grecaptcha === 'undefined') {
				submitSubscribeForm();
				return false;
			}

			// Mint a fresh token, write it to the hidden input, then submit.
			grecaptcha.ready(function() {
				grecaptcha.execute(siteKey, { action: 'submit' }).then(function(token) {
					recaptchaField.val(token);
					submitSubscribeForm();
				}).catch(function() {
					handleRecaptchaError();
					modal.removeClass('modal--loading');
				});
			});

			return false;
		});
	}

	init();
});

/**
 * Handle submission of the subscribe form
 * Moved to the global scope so that recaptcha has access to it via callback
 */
function submitSubscribeForm() {
	var modal = $('#subscribe_modal'),
		form = modal.find('form'),
		url = form.attr('action'),
		data = form.serializeArray();

	// $('#subscribe_modal_content').html('');
	modal.addClass('modal--loading');

	$.ajax({
		url: url,
		type: 'post',
		data: data,
		success: function (html) {
			modal.removeClass('modal--loading');
			var error = $(html).find('#Form_SubscribeForm_error');
			// if we have errors, we append that to the form
			if (error.length) {
				$('#Form_SubscribeForm').prepend(error);
			} else {
				$('#subscribe_modal_content').html('');
				$('#subscribe_modal_content').html($(html).find('#ajax_content'));
				modal.removeClass('modal--active');
			}
		},
		error: function (response) {
			console.log('Error: ' + response);
			modal.removeClass('modal--active');
		}
	});
}

/**
 * Handle errors received from Recaptcha - in particular:
 * "Cannot contact reCAPTCHA. Check your connection and try again"
 * Moved to the global scope so that recaptcha has access to it via callback
 */
function handleRecaptchaError() {
    $('[data-recaptcha-error]').slideDown();
}

(function() {
	/**
	 * Tool tips
	 */
	DO.Subscribe(['app:ready', 'ajax:success'], function(e, $) {
		$('[data-toggle="tooltip"]').tooltip({
			container: 'body',
			animation: true
		});
	});
})();

/**
* Init and extras for youtube videos
*/
DO.Subscribe('app:ready', function(e, $) {
	'use strict';

	function init() {
		setup($(document));
	}

	function setup(scope) {
		var embedded = scope.find('[data-embedded-video]');

		if (embedded.length > 0) {
			setUpEmbedded(embedded);
		}
		attachEvents(scope);
	}

	/**
	 *
	 * @param scope
	 */
	function attachEvents(scope) {
		scope.on('click', '[data-video-url]', function() {
			handleSwitch(this, $(this).data('target'));
			handleYoutube(this, $(this).data('target'));
		});

		scope.on('hide.bs.modal', '[data-modal-video]', function() {
			destroyPlayer(this);
		});

		scope.on('shown.bs.modal', '[data-modal-video]', function() {
			// Fix the focus, since we've moved it to content
			var target = $(this)
				.find('[tabindex]')
				.first();
			target.focus();
		});
	}

	function handleSwitch (self, target) {
		var modal = $(target);

		if ($(self).data('modal-transcript')) {
			modal.removeClass('modal--videoonly');

			return;
		}

		modal.addClass('modal--videoonly');
	}

	/**
	 * Used to init on page (non-modal) youtube video
     * @param embedded
     */
	function setUpEmbedded(embedded) {
		var i;

		for (i = 0; i < embedded.length; i = i + 1) {
			handleYoutube($(embedded[i]), $(embedded[i]));
		}
	}

	/**
	 *
	 * @param scope
	 * @returns {boolean}
	 */
	function destroyPlayer(scope) {
		$(scope)
			.find('iframe')
			.remove();
	}

	/**
	 *
	 * @param self
	 */
	function handleYoutube(self, target) {
		createPlayer(self, $(target));

		if ($(self).data('modal-transcript')) {
			setTimeout(function() {
				scrollToTranscript(self);
			}, 500);
		}
	}

	/**
	 *
	 * @param self
	 */
	function scrollToTranscript(self) {
		var targetID = $(self).data('modal-transcript'),
			target = document.getElementById(targetID);

		if (target !== null) {
			target.scrollIntoView(true);
		}
	}

	/**
	 *
	 * @param self
	 * @param target
	 */
	function createPlayer(self, target) {
		var autoPlay = 1,
			videoEl = target.data('video-render')
				? target
				: target.find('[data-video-render]'),
			videoId,
			origin;

		if ($(self).data('modal-transcript') || $(self).data('embedded-video')) {
			autoPlay = 0;
		}

		videoId = getYTvid($(self).data('video-url'));
		origin = location.protocol + '//' + location.hostname;

		videoEl.append(
			$(
				'<iframe src="https://www.youtube.com/embed/' +
					videoId +
					'?enablejsapi=1&iv_load_policy=3&origin=' +
					origin +
					'&autoplay=' +
					autoPlay +
					'&showinfo=0&rel=0" frameborder="0"></iframe>'
			)
		);
	}

	/**
	 *
	 * @param url
	 * @returns {*}
	 */
	function getYTvid(url) {
		if (/youtu\.be/.test(url)) {
			return url
				.split('youtu.be/')[1]
				.split('?')[0]
				.split('&')[0]
				.split('#')[0];
		} else if (/youtube\.com\/v\//.test(url)) {
			return url
				.split('youtube.com/v/')[1]
				.split('?')[0]
				.split('&')[0]
				.split('#')[0];
		} else if (/youtube\.com\/embed\//.test(url)) {
			return url
				.split('youtube.com/embed/')[1]
				.split('?')[0]
				.split('&')[0]
				.split('#')[0];
		} else if (
			/youtube.com|youtuberepeater.com|listenonrepeat.com/.test(url)
		) {
			return url.split('v=')[1].split('&')[0].split('#')[0];
		} else {
			return false;
		}
	}

	init();
});
